import React, { useContext, useEffect } from 'react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { Button, Paper, Stack, TextField } from '@mui/material';
import { StepButtons } from '../StepButtons';
import { ReverseCollectContext } from '../..';
import { Title } from './styled';

export const SearchKnowledge = () => {
  const { handleNextStep, knowledgeNumber, openSearchKnowledgeModal } =
    useContext(ReverseCollectContext);

  const searchKnowledgeSchema = Yup.object().shape({
    knowledgeNumber: Yup.string()
  });

  const {
    handleSubmit,
    control,
    setValue,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(searchKnowledgeSchema),
    reValidateMode: 'onChange'
  });

  const onSubmit = (data) => {
    handleNextStep();
  };

  useEffect(() => {
    setValue('knowledgeNumber', knowledgeNumber);
    clearErrors();
  }, [knowledgeNumber]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Paper
        elevation={2}
        style={{
          position: 'relative',
          marginTop: 16,
          padding: '20px 16px 16px'
        }}
      >
        <Title>
          Pesquisar conhecimento caso o embarque tenha sido realizado pela
          Braspress:
        </Title>

        <Stack
          direction="row"
          spacing={2}
          style={{ marginTop: 16, alignItems: 'flex-start' }}
        >
          {knowledgeNumber && (
            <Controller
              name="knowledgeNumber"
              defaultValue=""
              control={control}
              render={({ field }) => (
                <TextField
                  label="Número Conhecimento"
                  size="small"
                  disabled
                  {...field}
                  onChange={(e) => field.onChange(e.target.value)}
                  onBlur={(e) => {
                    field.onBlur(field.onChange(e.target.value));
                  }}
                  inputProps={{ maxLength: 256 }}
                  error={!!errors.knowledgeNumber}
                  helperText={errors.knowledgeNumber?.message}
                />
              )}
            />
          )}

          <Button
            type="button"
            variant="contained"
            onClick={openSearchKnowledgeModal}
            style={{ height: 40 }}
          >
            Pesquisar
          </Button>
        </Stack>
      </Paper>

      <StepButtons nextFunction={handleSubmit(onSubmit)} />
    </form>
  );
};
